export const API = process.env.NODE_ENV === "production"
  ? window.location.origin
  : (process.env.REACT_APP_API_URL || "http://127.0.0.1:5001");
const KEY = "cozobi_session";

export const getSession = () => {
  try { return JSON.parse(localStorage.getItem(KEY)); } catch { return null; }
};
export const setSession = (s) =>
  s ? localStorage.setItem(KEY, JSON.stringify(s)) : localStorage.removeItem(KEY);

export async function api(path, { method = "GET", body } = {}) {
  const session = getSession();
  let res;
  try {
    res = await fetch(API + path, {
      method,
      headers: {
        "Content-Type": "application/json",
        ...(session ? { Authorization: `Bearer ${session.token}` } : {}),
      },
      body: body ? JSON.stringify(body) : undefined,
    });
  } catch {
    throw new Error("No se pudo conectar con el servidor");
  }
  let data = null;
  try { data = await res.json(); } catch {}

  // Sesión vencida, cuenta suspendida o eliminada: regresa al login
  const blocked = res.status === 403 && ["Cuenta suspendida", "Cuenta eliminada"].includes(data?.error);
  if (session && (res.status === 401 || blocked)) {
    setSession(null);
    window.location.reload();
  }
  if (!res.ok) throw new Error(data?.error || "Error del servidor");
  return data;
}

/* ---------- Formato ---------- */
export const money = (n) =>
  Number(n || 0).toLocaleString("es-MX", { style: "currency", currency: "MXN", minimumFractionDigits: 0, maximumFractionDigits: 2 });

const toDate = (v) => {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(v);
  return m ? new Date(+m[1], +m[2] - 1, +m[3]) : new Date(v);
};
export const productName = (o) =>
  o.product_type === "COMPOSTA" ? "Composta (saco 20 kg)" : `Lixiviado ${o.product_type}`;
// El servidor manda fecha y hora como "2026-10-05 20:15:00" (hora de Hermosillo).
// Safari no entiende el espacio, por eso se cambia por una "T".
export const dt = (v) => new Date(String(v).replace(" ", "T"));

export const fmtDate = (v) =>
  v ? toDate(v).toLocaleDateString("es-MX", { day: "numeric", month: "short" }) : "—";

export const fmtDateTime = (v) =>
  v ? dt(v).toLocaleString("es-MX", { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" }) : "—";

export const ago = (v) => {
  const min = Math.max(0, Math.round((Date.now() - dt(v).getTime()) / 60000));
  if (min < 1) return "ahora";
  if (min < 60) return `hace ${min} min`;
  if (min < 1440) return `hace ${Math.round(min / 60)} h`;
  return `hace ${Math.round(min / 1440)} d`;
};

// Tiempo que falta para una fecha límite: "20 h 15 min" o "vencido"
export const timeLeft = (v) => {
  const min = Math.round((dt(v).getTime() - Date.now()) / 60000);
  if (min <= 0) return "vencido";
  if (min < 60) return `${min} min`;
  return `${Math.floor(min / 60)} h ${min % 60} min`;
};

const p2 = (n) => String(n).padStart(2, "0");
export const todayStr = () => {
  const d = new Date();
  return `${d.getFullYear()}-${p2(d.getMonth() + 1)}-${p2(d.getDate())}`;
};
export const addDays = (str, n) => {
  const d = toDate(str);
  d.setDate(d.getDate() + n);
  return `${d.getFullYear()}-${p2(d.getMonth() + 1)}-${p2(d.getDate())}`;
};

/* ---------- Enlaces útiles ---------- */
export const waLink = (phone, text = "") =>
  `https://wa.me/52${phone}${text ? `?text=${encodeURIComponent(text)}` : ""}`;
export const mapsLink = (address) =>
  `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address + ", Hermosillo, Sonora")}`;